import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { BACKGROUND_COLOR_BLACK } from '~/src/features/movix-new/constants';

import { HeaderMainText, SubText } from '~/src/features/movix-new/HeaderTitileBlock/styled';

export const HeaderBlock = styled.header<{ backgroundImg: string }>`
    width: 100%;
    height: 678px;
    background-image: url(${props => props.backgroundImg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 450px;
    }

    @media (max-width: 640px) {
        height: 565px;
    }

    @media (max-width: 375px) {
        height: 380px;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
`;

export const ContainerMobileTitle = styled.div`
    width: 100%;
    position: relative;;
    background-color: ${BACKGROUND_COLOR_BLACK};

    ${HeaderMainText} {
        @media (max-width: ${wideBreakpoints.tablet}) {
            max-width: 590px;
            margin-top: 25px;
            margin-left: 0;
            ${FONTS.H3};
            text-align: left;
        }
    }

    ${SubText} {
        margin-top: 8px;
        ${FONTS.XS};

        @media (max-width: ${wideBreakpoints.tablet}) {
            width: 515px;
            ${FONTS.M};
            margin-left: 0;
            text-align: left;
        }

        @media (max-width: ${wideBreakpoints.mobile}) {
            width: 100%;
            ${FONTS.XS};
            margin-right: 16px;
        }
    }
`;
